<template>
  <UiSectionWrapper
    title="Kirim dengan Tenang, Karena Kami Siaga Saat Risiko Datang!"
    sub-title="Klaim Asuransi & Retur"
    hero-image="/images/klaim-asuransi-dan-retur-banner-4.webp"
    class="bg-primary-container dark:bg-surface-container-high py-10 lg:py-0"
    image-class="hidden lg:block"
    button-label="Ajukan Klaim"
    :button-link="
      $utm.utmUrl('/login', {
        redirectTo: '/package-claim'
      })
    "
  />
</template>
